import { type VehicleMake, VEHICLE_SEPARATOR } from '../services/vehicleService';

// Vehicle data used as fallback when API is unavailable
export const VEHICLE_MAKES: VehicleMake[] = [
  {
    id: 'mazda',
    name: 'Mazda',
    models: [
      {
        id: 'rx-7',
        name: 'RX-7',
        types: [
          {
            id: 'fb',
            name: 'SA/FB',
            years: '1978-1985'
          },
          {
            id: 'fc',
            name: 'FC',
            years: '1985-1992'
          },
          {
            id: 'fd',
            name: 'FD',
            years: '1992-2002'
          }
        ]
      },
      // {
      //   id: 'mx5',
      //   name: 'MX-5/Miata',
      //   types: [
      //     {
      //       id: 'na',
      //       name: 'NA',
      //       years: '1989-1997'
      //     },
      //     {
      //       id: 'nb',
      //       name: 'NB',
      //       years: '1998-2005'
      //     },
      //     {
      //       id: 'nc',
      //       name: 'NC',
      //       years: '2005-2015'
      //     },
      //     {
      //       id: 'nd',
      //       name: 'ND',
      //       years: '2015-present'
      //     }
      //   ]
      // }
    ]
  },
  {
    id: 'porsche',
    name: 'Porsche',
    models: [
      {
        id: '356',
        name: '356',
        types: [
          {
            id: '356',
            name: '356',
            years: '1948-1965'
          }
        ]
      },
      {
        id: '911',
        name: '911',
        types: [
          {
            id: '911',
            name: '911',
            years: '1963-1973'
          },
          {
            id: '964',
            name: '964',
            years: '1989-1994'
          },
          {
            id: '993',
            name: '993',
            years: '1994-1998'
          },
          {
            id: '996',
            name: '996',
            years: '1997-2005'
          },
          {
            id: '997',
            name: '997',
            years: '2004-2012'
          },
          {
            id: '991',
            name: '991',
            years: '2011-2019'
          },
          {
            id: '992',
            name: '992',
            years: '2019-present'
          }
        ]
      },
      {
        id: '912',
        name: '912',
        types: [
          {
            id: '912',
            name: '912',
            years: '1965-1969'
          }
        ]
      },
      {
        id: '914',
        name: '914',
        types: [
          {
            id: '914',
            name: '914',
            years: '1969-1976'
          }
        ]
      },
      {
        id: '918',
        name: '918',
        types: [
          {
            id: '918',
            name: '918',
            years: '2013-2015'
          }
        ]
      },
      {
        id: '924/931',
        name: '924/931',
        types: [
          {
            id: '924/931',
            name: '924/931',
            years: '1976-1988'
          }
        ]
      },
      {
        id: '928',
        name: '928',
        types: [
          {
            id: '928',
            name: '928',
            years: '1977-1995'
          }
        ]
      },
      {
        id: '944',
        name: '944',
        types: [
          {
            id: '944',
            name: '944',
            years: '1981-1991'
          }
        ]
      },
      {
        id: '960',
        name: '960',
        types: [
          {
            id: '960',
            name: '960',
            years: '1990-1997'
          }
        ]
      },
      {
        id: '968',
        name: '968',
        types: [
          {
            id: '968',
            name: '968',
            years: '1991-1995'
          }
        ]
      },
      {
        id: 'boxter',
        name: 'Boxster',
        types: [
          {
            id: '986',
            name: '986',
            years: '1996-2004'
          },
          {
            id: '987',
            name: '987',
            years: '2004-2012'
          },
          {
            id: '981',
            name: '981',
            years: '2012-2016'
          }
        ]
      },
      {
        id: 'cayman',
        name: 'Cayman',
        types: [
          {
            id: '987',
            name: '987',
            years: '2005-2012'
          },
          {
            id: '981',
            name: '981',
            years: '2012-2016'
          }
        ]
      },
      {
        id: '718',
        name: '718',
        types: [
          {
            id: '718',
            name: '718',
            years: '2016-present'
          }
        ]
      },
      {
        id: 'carrera-gt',
        name: 'Carrera GT',
        types: [
          {
            id: 'carrera-gt',
            name: 'Carrera GT',
            years: '2003-2007'
          }
        ]
      },
      {
        id: 'cayenne',
        name: 'Cayenne',
        types: [
          {
            id: '955/957',
            name: '955/957',
            years: '2002-2010'
          },
          {
            id: '958',
            name: '958',
            years: '2010-2017'
          },
          {
            id: '9Y0',
            name: '9Y0',
            years: '2017-present'
          }
        ]
      },
      {
        id: 'macan',
        name: 'Macan',
        types: [
          {
            id: '1st-gen',
            name: '1st Gen',
            years: '2014-present'
          },
          {
            id: 'ev',
            name: 'EV',
            years: '2024-present'
          }
        ]
      },
      {
        id: 'panamera',
        name: 'Panamera',
        types: [
          {
            id: '1st-gen',
            name: '1st Gen',
            years: '2009-2016'
          }
        ]
      },
      {
        id: 'taycan',
        name: 'Taycan',
        types: [
          {
            id: '1st-gen',
            name: '1st Gen',
            years: '2019-present'
          }
        ]
      }
    ]
  },
  {
    id: 'chevrolet',
    name: 'Chevrolet',
    models: [
      {
        id: 'corvette',
        name: 'Corvette',
        types: [
          {
            id: 'c1',
            name: 'C1',
            years: '1953-1962'
          },
          {
            id: 'c2',
            name: 'C2',
            years: '1963-1967'
          },
          {
            id: 'c3',
            name: 'C3',
            years: '1968-1982'
          },
          {
            id: 'c4',
            name: 'C4',
            years: '1984-1996'
          },
          {
            id: 'c5',
            name: 'C5',
            years: '1997-2004'
          },
          {
            id: 'c6',
            name: 'C6',
            years: '2005-2013'
          },
          {
            id: 'c7',
            name: 'C7',
            years: '2014-2019'
          },
          {
            id: 'c8',
            name: 'C8',
            years: '2020-present'
          }
        ]
      }
    ]
  }
];